import { render, staticRenderFns } from "./hazardInvestigation.vue?vue&type=template&id=4eaf0c2f"
import script from "./hazardInvestigation.vue?vue&type=script&lang=js"
export * from "./hazardInvestigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eaf0c2f')) {
      api.createRecord('4eaf0c2f', component.options)
    } else {
      api.reload('4eaf0c2f', component.options)
    }
    module.hot.accept("./hazardInvestigation.vue?vue&type=template&id=4eaf0c2f", function () {
      api.rerender('4eaf0c2f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/hazardInvestigation.vue"
export default component.exports